
import React from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export default function Navbar() {
  let history = useNavigate();
  const HandleLogout= ()=>{
    localStorage.clear()
    history('/login')
  }
  return (
    <>
      <nav className="navbar navbar-expand-lg bg-dark border-bottom border-body" data-bs-theme="dark">
        <div className="container-fluid">
          <NavLink className="navbar-brand" to="/">
            NoteVault
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="nav-link " aria-current="page" to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" aria-current="page" to="/About">
                  About
                </NavLink>
              </li>
            </ul>
           {!localStorage.getItem('token')?<form className="d-flex" role="search">
              <NavLink className="btn btn-primary mx-2" to = "/login" role="button">
                Login
              </NavLink>
              <NavLink className="btn btn-primary" to = "/signup" role="button">
                Signup
              </NavLink>
            </form>:<button className="btn btn-primary" onClick={HandleLogout}>Logout </button>}
          </div>
        </div>
      </nav>
    </>
  );
}
